import {Injectable, Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Pipe({
  name: 'htmlSanitize'
})

@Injectable()
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }

  transform(dynamicMessage: string): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(dynamicMessage);
  }
}
